import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from 'src/app/models/product.model';
import { ProductService } from 'src/app/services/product.service';
import { pathRoutingEnum } from 'src/assets/constantEnum';
import { getVoteLevel, VoteLevel } from 'src/app/shared/vote-level';

@Component({
    selector: 'app-hot-deals-sidebar',
    templateUrl: './hot-deals-sidebar.component.html',
    styleUrls: ['./hot-deals-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HotDealsSidebarComponent implements OnInit {

  // 'list' : colonne de droite (desktop) ; 'carousel' : haut de l'accueil mobile
  @Input() layout: 'list' | 'carousel' = 'list';

  products: Product[] = [];

  constructor(
    private productService: ProductService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.productService.getTopVotedProducts(this.layout === 'carousel' ? 8 : 5).subscribe(products => {
      this.products = products || [];
    });
  }

  getVoteLevel(product: Product): VoteLevel {
    return getVoteLevel(product.voteScore);
  }

  onDetails(product: Product) {
    if (product._id) {
      this.router.navigateByUrl(pathRoutingEnum.product.valueOf() + '/' + product._id);
    }
  }

}
